// // RightSideDrawer.js
// import React from 'react';

// const RightSideDrawer = ({ id = 'rightDrawer', title, children, show, onClose }) => {
//   return (
//     <div
//       className={`offcanvas offcanvas-end ${show ? 'show' : ''}`}
//       tabIndex="-1"
//       id={id}
//       style={{ visibility: show ? 'visible' : 'hidden' }}
//     >
//       <div className="offcanvas-header">
//         <h5 className="offcanvas-title">{title}</h5>
//         <button type="button" className="btn-close text-reset" onClick={onClose}></button>
//       </div>
//       <div className="offcanvas-body">
//         {children}
//       </div>
//     </div>
//   );
// };

// export default RightSideDrawer;


import React from 'react';

const RightSideDrawer = ({ id = 'rightDrawer', title, subtitle, children, show, onClose }) => {
    return (
        <>
            {/* Backdrop */}
            {show && (
                <div
                    className="custom-backdrop"
                    onClick={onClose}
                ></div>
            )}

            {/* Offcanvas Drawer */}
            <div
                className={`offcanvas offcanvas-end ${show ? 'show' : ''}`}
                tabIndex="-1"
                id={id}
                style={{ visibility: show ? 'visible' : 'hidden' }}
            >
                <div className="offcanvas-header pb-0">
                    <div className="">
                        <h5 className="offcanvas-title">{title}</h5>
                        <p className="mb-0">{subtitle}</p>
                    </div>
                    <button type="button" className="btn-close text-reset" onClick={onClose}></button>
                </div>
                <div className='px-3'>
                    <hr style={{ color: '#E4E8F1' }} />
                </div>
                <div className="offcanvas-body">
                    {children}
                </div>
            </div>
        </>
    );
};

export default RightSideDrawer;
